// Ball colors with glow values
export const COLORS = {
  pink:   { bg: '#ff2d9b', glow: '#ff2d9b', light: '#ff80c0', dark: '#cc0066' },
  blue:   { bg: '#00d4ff', glow: '#00d4ff', light: '#80eaff', dark: '#0088bb' },
  orange: { bg: '#ff7700', glow: '#ff9900', light: '#ffbb66', dark: '#cc5500' },
  purple: { bg: '#b44dff', glow: '#cc66ff', light: '#d999ff', dark: '#7700cc' },
  green:  { bg: '#00ff88', glow: '#00ff88', light: '#80ffbb', dark: '#00cc66' },
  yellow: { bg: '#ffe600', glow: '#ffe600', light: '#fff080', dark: '#ccb800' },
  red:    { bg: '#ff3355', glow: '#ff3355', light: '#ff8899', dark: '#cc1133' },
  teal:   { bg: '#00ffe5', glow: '#00ffe5', light: '#80fff2', dark: '#00ccb8' },
};

export const COLOR_KEYS = Object.keys(COLORS);

// Level configurations: [numColors, numEmptyTubes, tubeCapacity]
const LEVEL_CONFIG = [
  [3, 2, 4], [4, 2, 4], [5, 2, 4], [5, 3, 4],
  [6, 2, 4], [6, 3, 4], [7, 2, 4], [7, 3, 4],
  [8, 2, 4], [8, 3, 4],
];

export function getLevelConfig(level) {
  const idx = Math.min(level - 1, LEVEL_CONFIG.length - 1);
  const [numColors, numEmpty, cap] = LEVEL_CONFIG[idx];
  return { numColors, numEmpty, capacity: cap };
}

export function generateLevel(level) {
  const { numColors, numEmpty, capacity } = getLevelConfig(level);
  const colorList = COLOR_KEYS.slice(0, numColors);

  // Create a full pool of balls: each color appears `capacity` times
  let pool = [];
  colorList.forEach(c => { for (let i = 0; i < capacity; i++) pool.push(c); });

  // Shuffle
  for (let i = pool.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }

  // Fill tubes (bottom = index 0, top = index capacity-1)
  const tubes = [];
  for (let t = 0; t < numColors; t++) {
    tubes.push(pool.slice(t * capacity, (t + 1) * capacity));
  }
  // Add empty tubes
  for (let e = 0; e < numEmpty; e++) tubes.push([]);

  return tubes;
}

export function canMove(tubes, fromIdx, toIdx, capacity) {
  const from = tubes[fromIdx];
  const to = tubes[toIdx];
  if (from.length === 0) return false;
  if (to.length >= capacity) return false;
  if (to.length === 0) return true;
  return from[from.length - 1] === to[to.length - 1];
}

export function moveBall(tubes, fromIdx, toIdx) {
  const newTubes = tubes.map(t => [...t]);
  const ball = newTubes[fromIdx].pop();
  newTubes[toIdx].push(ball);
  return newTubes;
}

export function checkWin(tubes, capacity) {
  return tubes.every(tube =>
    tube.length === 0 ||
    (tube.length === capacity && tube.every(b => b === tube[0]))
  );
}

export function deepClone(tubes) {
  return tubes.map(t => [...t]);
}
